import type { NEmployees } from '@app/types';

export type AddProductFormValues = {
  Name: string;
  NameShort: string | null;
  Article: string | null;
  BarCode: string | null;
  ProductCategoryId: number | null;
  ProductBrandId: number | null;
  UnitOfMeasurementId: number | null;
  Amount: string | null;
  Comment: string | null;
  WarehouseId: number | null;
  SupplierId: number | null;
  Count: number | null;
  PriceOfPurchase: number | null;
  PriceOfSale: number | null;
  Markup: number | null;
};

export interface UpdateBrandHandlerProps {
  Name: string;
  Description: string;
}

export interface FastCreationModalProps {
  title?: string;
  finishModal: NEmployees.FinishModal | NEmployees.CreateLegalEntity;
}

export enum FastCreationModalTypes {
  ADD_PRODUCT_CATEGORY = 'addCategory',
  ADD_PRODUCT_BRAND = 'addBrand',
}
